module.exports = __webpack_public_path__ + "static/Avbas_logo-8581d95b5e53caed7d0328d2dc34a7bc.png";